import { getStartEndIsoDate } from '@/utils/getStartEndIsoDate';

import type { ExportSettingsType } from '../types/context.types';

export const getFromToValues = (exportSettings: ExportSettingsType) => {
  let fromValue: string | null;
  let toValue: string | null = '';

  switch (exportSettings.dateRangeType) {
    case 'all':
      fromValue = 'all';
      break;
    case 'range':
      fromValue = `${exportSettings.periodNumber}${exportSettings.period}`;
      break;
    case 'dates':
      fromValue = getStartEndIsoDate(exportSettings.from, 'start');
      toValue = getStartEndIsoDate(exportSettings.to, 'end');
      break;
    default:
      fromValue = 'all';
  }

  return { fromValue, toValue };
};
